export const ABB_EDIT = "abb/edit";
export const ABB_PLUS = "abb/plus";
export const ABB_VIEW = "abb/view";
export const ABB_CLOSE = "abb/close";
export const ABB_COPY = "abb/copy";
export const ABB_NEW = "abb/new-document";
export const ABB_CHECK_MARK = "abb/check-mark";
export const ABB_CARET_UP = "abb/caret-up";
export const ABB_CARET_RIGHT = "abb/caret-right";
export const ABB_CARET_DOWN = "abb/caret-down";
export const ABB_TRASH = "abb/trash";
export const ABB_MINUS_IN_CIRCLE = "abb/minus-in-circle";
export const ABB_LEFT = "abb/left";
export const ABB_RIGHT = "abb/right";
export const ABB_REFRESH = "abb/refresh";
export const ABB_WARNING = "abb/warning-triangle";
export const ABB_PLAY = "abb/play";
export const ABB_STOP = "abb/stop";
export const ABB_PAUSE = "abb/pause";
export const ABB_HOUR_GLASS = "abb/hour-glass";
export const ABB_REPORT = "abb/reports";
export const ABB_MENU_NARROW = "abb/menu_narrow";
export const ABB_FULLSCREEN = "abb/fullscreen";
export const ABB_MIDSCREEN = "abb/minimize";
export const ABB_HIDE = "abb/hide";
export const ABB_PROGRAM_POINTER = "abb/program-pointer";
export const ABB_INFORMATION = "abb/information-circle-1";
export const ABB_ALARM_BELL = "abb/alarm-bell";
export const ABB_GRAPH_VIEW = "abb/trend-3";
export const ABB_TABLE_VIEW = "abb/list";
export const ABB_WAITING = "abb/hour-glass";
export const ABB_QR_CODE = "abb/qr-code";
